import {helmTokens} from '@sail/helm';
import {css} from '@sail/ui';

export const styles = {
  container: css({
    gap: 'small',
    alignY: 'baseline',
    listStyleType: 'none',
    font: 'body.medium',
    textColor: 'text',
  }),
  containerUnprocessedCss: css({
    display: 'flex',
    letterSpacing: `${helmTokens.letterSpacing.large}`,
  }),
  icon: css({
    flexShrink: 0,
    position: 'relative',
    top: '5px',
  }),
};
